import { useMemo } from 'react'

import { StructureObjectDto } from '@/endpoints/models'
import { useDetailTabContext } from '@/pages/User/pages/Home/components/DetailTab/context/DetailTabContext'
import { StructureDto } from '@/rtkApi/mddApiSliceGenerated'
import { NamingDtoTypeEnum, SqlTypeEnum } from '@/types'

export const useGetNamingConfig = (form: Record<string, unknown>, node?: StructureDto) => {
	const detailTabContext = useDetailTabContext()

	const namingConfig = useMemo(() => {
		if (node === undefined || detailTabContext === undefined) {
			return undefined
		}

		const {
			state: { editMode },
		} = detailTabContext

		if (!editMode) {
			return undefined
		}

		switch (node.type) {
			case StructureObjectDto.TypeEnum.API_COLLECTION: {
				return [
					NamingDtoTypeEnum.API_COLLECTION_CODE,
					node.id,
					SqlTypeEnum.API_COLLECTION,
					{
						body: { data: JSON.stringify(form) },
					},
				] as const
			}

			case StructureObjectDto.TypeEnum.API_NODE: {
				return [
					NamingDtoTypeEnum.API_NODE_CODE,
					node.id,
					SqlTypeEnum.API_NODE,
					{
						body: { data: JSON.stringify(form) },
					},
				] as const
			}

			case StructureObjectDto.TypeEnum.QUEUE: {
				return [
					NamingDtoTypeEnum.QUEUE_CODE,
					node.id,
					SqlTypeEnum.QUEUE,
					{
						body: { data: JSON.stringify(form) },
					},
				] as const
			}

			case StructureObjectDto.TypeEnum.VIEW: {
				return [
					NamingDtoTypeEnum.VIEW_CODE,
					node.id,
					SqlTypeEnum.VIEW,
					{
						body: { data: JSON.stringify(form) },
					},
				] as const
			}

			case StructureObjectDto.TypeEnum.MAPPING_READ: {
				return [
					NamingDtoTypeEnum.MAPPING_CODE,
					node.id,
					SqlTypeEnum.MAPPING_READ,
					{
						body: { data: JSON.stringify(form) },
					},
				] as const
			}

			case StructureObjectDto.TypeEnum.MAPPING_WRITE: {
				return [
					NamingDtoTypeEnum.MAPPING_CODE,
					node.id,
					SqlTypeEnum.MAPPING_WRITE,
					{
						body: { data: JSON.stringify(form) },
					},
				] as const
			}

			case StructureObjectDto.TypeEnum.WORKFLOW: {
				return [
					NamingDtoTypeEnum.WORKFLOW_CODE,
					node.id,
					SqlTypeEnum.WORKFLOW,
					{
						body: { data: JSON.stringify(form) },
					},
				] as const
			}

			case 'DIAGRAM': {
				return [
					NamingDtoTypeEnum.DIAGRAM_CODE,
					node.id,
					SqlTypeEnum.DIAGRAM,
					{
						body: { data: JSON.stringify(form) },
					},
				] as const
			}

			default: {
				console.error('Unknown structure type in useGetNamingConfig')

				return undefined
			}
		}
	}, [detailTabContext, form, node])

	return namingConfig
}
